import { authClient } from './client';
import ExtractErrorMessage from '../utils/extractErrorMessage';

const mobileInfoPageService = {
  getForAdmin: async () => {
    try {
      return (await authClient.get('/mobile-info-page/admin/get')).data;
    } catch (error) {
      const message = ExtractErrorMessage(error, 'Došlo je do greške');
      return { data: null, success: false, message };
    }
  },

  update: async (data) => {
    try {
      return (await authClient.put('/mobile-info-page/update', data)).data;
    } catch (error) {
      const message = ExtractErrorMessage(error, 'Došlo je do greške');
      return { data: null, success: false, message };
    }
  },
};

export default mobileInfoPageService;
